"use strict";

(function () {
  'use strict';

  angular.module('lr.Graphs').directive('morrisBar', ['$window', '$timeout', function ($window, $timeout) {
    return {
      restrict: 'AE',
      scope: {
        data: '=',
        control: '=',
        width: '@',
        height: '@',
        id: '@',
        xkey: '@',
        ykeys: '=',
        labels: '=',
        barColors: '@',
        stacked: '@',
        hideHover: '@',
        axes: '@',
        grid: '@',
        gridTextColor: '@',
        gridTextSize: '@',
        gridTextFamily: '@',
        gridTextWeight: '@'
      },
      link: function link(scope, ele, attrs) {
        var renderTimeout,
            id,
            graphObject = {},
            resizeTimeout,
            shouldRender = true,
            bar;
        angular.element($window).bind('resize', function () {
          // $window.onresize = function () {
          if (!shouldRender) {
            return;
          }

          if (resizeTimeout) {
            $timeout.cancel(resizeTimeout);
          }

          resizeTimeout = $timeout(function () {
            scope.control.render(scope.data);
          }); //};
        });
        scope.$watch('data', function (newData) {
          scope.control.render(newData);
        }, true);

        scope.control.render = function (data) {
          if (!data) {
            return;
          }

          if (ele.width() === 0) {
            return;
          }

          if (renderTimeout) {
            clearTimeout(renderTimeout);
          }

          renderTimeout = $timeout(function () {
            if (ele.children().length > 0) {
              $('#' + attrs.id + ' svg').remove();
              $('#' + attrs.id + ' div.morris-hover.morris-default-style').remove();
            } //set the width and height of the ele


            ele[0].style.width = attrs.width === undefined ? '100%' : attrs.width;
            ele[0].style.height = attrs.height === undefined ? '300px' : attrs.height;
            id = attrs.id === undefined ? 'bargraph' + Math.floor(Math.random() * (100 - 1 + 1)) + 1 : attrs.id;
            ele[0].setAttribute('id', id); //for some reasons etting stacked to false is skewing the graphs.

            if (attrs.stacked == 'true') {
              graphObject = {
                element: id,
                data: data,
                xkey: attrs.xkey,
                ykeys: scope.ykeys,
                labels: scope.labels,
                hideHover: attrs.hideHover === undefined ? 'auto' : attrs.hideHover,
                stacked: true
              };
            } else {
              graphObject = {
                element: id,
                data: data,
                xkey: attrs.xkey,
                ykeys: scope.ykeys,
                labels: scope.labels,
                hideHover: attrs.hideHover === undefined ? 'auto' : attrs.hideHover
              };
            }

            bar = new Morris.Bar(graphObject);
          });
        };

        scope.$on('$destroy', function () {
          angular.element($window).unbind('resize');
          shouldRender = false;
          bar = {};
        });
      }
    };
  }]).directive('morrisPie', ['$window', '$timeout', function ($window, $timeout) {
    return {
      restrict: 'AE',
      scope: {
        data: '=',
        //our data
        colors: '='
      },
      link: function link(scope, ele, attrs) {
        var renderTimeout;
        var id;
        var pie;
        var loader = $('<i class="lr-loading-icon fa fa-circle-o-notch fa-spin" style="position: relative;top: 90px;left: 35%;"></i>');

        function load() {
          ele.append(loader);
        }

        function clear() {
          $('#' + attrs.id + ' svg').remove();
          $('#' + attrs.id + ' div.morris-hover.morris-default-style').remove();
        }

        scope.$watch('data', function (newData) {
          scope.render(newData);
        }, true);

        scope.render = function (data) {
          load();

          if (!data) {
            return;
          }

          if (renderTimeout) {
            clearTimeout(renderTimeout);
          }

          renderTimeout = $timeout(function () {
            if (ele.children().length > 0) {
              clear();
            }

            loader.remove();
            var total = 0;

            for (var i = 0, len = data.length; i < len; i++) {
              total += data[i].value;
            }

            if (total <= 0) {
              return;
            } //set the width and height of the ele


            ele[0].style.width = attrs.width === undefined ? '100%' : attrs.width;
            ele[0].style.height = attrs.height === undefined ? '300px' : attrs.height;
            id = attrs.id === undefined ? 'pieGraph' + Math.floor(Math.random() * (100 - 1 + 1)) + 1 : attrs.id;
            ele[0].setAttribute('id', id);
            pie = new Morris.Donut({
              element: id,
              data: data,
              colors: scope.colors
            });
          });
        };
      }
    };
  }]).directive('morrisLine', ['$window', '$timeout', function ($window, $timeout) {
    return {
      restrict: 'AE',
      scope: {
        data: '=',
        width: '@',
        height: '@',
        id: '@',
        xkey: '@',
        ykeys: '=',
        labels: '=',
        lineColors: '@',
        lineWidth: '@',
        pointSize: '@',
        pointFillColors: '@',
        pointStrokeColors: '@',
        ymax: '@',
        ymin: '@',
        smooth: '@',
        hideHover: '@',
        parseTime: '@',
        postUnits: '@',
        preUnits: '@',
        xLabels: '@',
        xLabelFormat: '@',
        yLabelFormat: '@',
        goals: '@',
        goalStrokeWidth: '@',
        goalLineColors: '@',
        events: '@',
        eventStrokeWidth: '@',
        eventLineColors: '@',
        continuousLine: '@',
        grid: '@',
        gridTextColor: '@',
        gridTextSize: '@',
        gridTextFamily: '@',
        gridTextWeight: '@',
        fillOpacity: '@'
      },
      link: function link(scope, ele, attrs) {
        var renderTimeout,
            id,
            smooth,
            resizeTimeout,
            shouldRender = true,
            line;

        function dateFormat(timeStamp) {
          var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
          var date = timeStamp.getDate();
          var month = timeStamp.getMonth();
          var year = timeStamp.getFullYear();
          return months[month] + ' ' + date + ', ' + year;
        }

        $window.onresize = function () {
          if (!shouldRender) {
            return;
          }

          if (resizeTimeout) {
            $timeout.cancel(resizeTimeout);
          }

          resizeTimeout = $timeout(function () {
            scope.render(scope.data);
          });
        };

        scope.$watch('data', function (newData) {
          scope.render(newData);
        }, true);

        scope.render = function (data) {
          if (!data || data.length === undefined) {
            return;
          }

          if (renderTimeout) {
            clearTimeout(renderTimeout);
          }

          renderTimeout = $timeout(function () {
            if (ele.children().length > 0) {
              $('#' + attrs.id + ' svg').remove();
              $('#' + attrs.id + ' div.morris-hover.morris-default-style').remove();
              $('#' + attrs.id + ' #line-alert').remove();
            }

            if (data.length <= 0) {
              ele[0].innerHTML = '<div class="alert alert-info" ' + 'id="line-alert"' + 'style="position:relative; top:50%; width:150px; left: 35%;text-align:center;">' + 'Insufficient data.</div>';
              return;
            } //set the width and height of the ele


            ele[0].style.width = attrs.width || '100%';
            ele[0].style.height = attrs.height || '300px';
            id = attrs.id === undefined ? 'linegraph' + Math.floor(Math.random() * (100 - 1 + 1)) + 1 : attrs.id;
            ele[0].setAttribute('id', id);

            function commaSeparateNumber(val) {
              while (/(\d+)(\d{3})/.test(val.toString())) {
                val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
              }

              return val;
            }

            line = new Morris.Line({
              element: id,
              data: data,
              xkey: attrs.xkey,
              ykeys: scope.ykeys,
              labels: scope.labels,
              lineWidth: attrs.lineWidth === undefined ? 3 : attrs.lineWidth,
              pointSize: attrs.pointSize === undefined ? 3 : attrs.pointSize,
              pointStrokeColors: attrs.pointStrokeColors === undefined ? '#fff' : attrs.pointStrokeColors,
              ymax: attrs.ymax === undefined ? 'auto' : attrs.ymax,
              ymin: attrs.ymin === undefined ? 'auto' : attrs.ymin,
              smooth: smooth = attrs.smooth == 'true',
              hideHover: attrs.hideHover === undefined ? 'auto' : attrs.hideHover,
              hoverCallback: function hoverCallback(index, options) {
                var row = options.data[index];
                var colors = options.lineColors;
                var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
                var d = new Date(row.x);
                var date = d.getDate();
                var month = d.getMonth();
                var year = d.getFullYear();
                var returnString = months[month] + ', ' + date;
                return '<strong>' + returnString + '</strong><br/>' + '<span style="color:' + colors[0] + ';font-size: 14px"><strong>' + year + ':</strong> $ <span class="pull-right">' + commaSeparateNumber(row.y.toFixed(2)) + '</span></span>' + '<br/>' + '<span style="color:' + colors[1] + ';font-size: 14px"><strong>' + (year - 1) + ':</strong> $ <span class="pull-right">' + commaSeparateNumber(row.z.toFixed(2)) + '</span></span>';
              },
              parseTime: attrs.parseTime === undefined ? 'false' : attrs.parseTime,
              // postUnits: '@',
              // preUnits: '@',
              // dateFormat: '@',
              // xLabels: attrs.xlabels,
              xLabelFormat: function xLabelFormat(x) {
                return dateFormat(x);
              },
              yLabelFormat: function yLabelFormat(y) {
                return y.toFixed(2);
              } //   goals: '@',
              //  goalStrokeWidth: '@',
              //   goalLineColors: '@',
              //  events: '@',
              //  eventStrokeWidth: '@',
              //    eventLineColors: '@',
              //   continuousLine: attrs.continuousLine === undefined ? false : attrs.continuousLine,
              //   grid: attrs.grid === undefined ? false : attrs.grid,
              //   gridTextColor: attrs.gridTextColor === undefined ? '#888' : attrs.gridTextColor,
              //   gridTextSize: attrs.gridTextSize === undefined ? 12 : attrs.gridTextSize,
              //  gridTextFamily: attrs.gridTextFamily === undefined ? 'sans-serif' : attrs.gridTextFamily,
              //  gridTextWeight: attrs.gridTextWeight === undefined ? 'normal' : attrs.gridTextWeight,
              //   fillOpacity: attrs.fillOpacity === undefined ? '1.0' : attrs.fillOpacity,

            });
          });
        };

        scope.$on('$destroy', function () {
          shouldRender = false;
          line = {};
        });
      }
    };
  }]).directive('lrGauge', [function () {
    return {
      restrict: 'AE',
      scope: {
        range: '=',
        //our data
        value: '=',
        color: '=',
        title: '@'
      },
      link: function link(scope, ele) {
        function _calc(value, range) {
          return value / range * 180;
        }

        var gauge = $(ele.children()[0]);

        var newVal = _calc(scope.value, scope.range);

        gauge.find('.semi-circle').attr({
          style: 'background:' + scope.color
        });
        gauge.find('.semi-circle--mask').attr({
          style: '-webkit-transform: rotate(' + newVal + 'deg);' + '-moz-transform: rotate(' + newVal + 'deg);' + 'transform: rotate(' + newVal + 'deg);'
        });
      },
      template: '<div class="box ">' + ' <div class="mask"> ' + '  <div class="semi-circle"></div>' + '  <div class="semi-circle--mask"></div>' + ' </div> ' + ' <div class="semi-circle--zero">0</div>' + ' <div class="semi-circle--label center">{{value}}</div>' + ' <div class="semi-circle--title center">{{title}}</div>' + ' <div class="semi-circle--range">{{range}}</div>' + '</div>'
    };
  }]);
})();